// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photo-box img {
  position: absolute;
  top: 0;
  left: 5%;
  transform: translateY(50%);
  border-radius: 20px;
  width: 120px;
  height: 120px;
  object-fit: cover;
  padding: 1px;
  background-color: var(--planeed-color-white);
  border: 4px solid var(--planeed-color-white);
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
@media only screen and (max-width: 460px) {
  .photo-box img {
    transform: translateY(125%);
  }
}

.photo-box-space img {
  position: absolute;
  top: 0;
  left: 5%;
  transform: translateY(50%);
  border-radius: 120px;
  width: 120px;
  height: 120px;
  object-fit: cover;
  padding: 1px;
  background-color: var(--planeed-color-white);
  border: 4px solid var(--planeed-color-white);
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
@media only screen and (max-width: 460px) {
  .photo-box-space img {
    transform: translateY(125%);
  }
}

.modal-photo-box img {
  position: absolute;
  top: 0;
  left: 12px;
  transform: translateY(-65%);
  border-radius: 20px;
  width: 100px;
  height: 100px;
  object-fit: cover;
  padding: 1px;
  background-color: var(--planeed-color-white);
  border: 4px solid var(--planeed-color-white);
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.15);
  cursor: pointer;
  object-position: center center;
  padding: 0;
  border: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
